import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=87c2b412&scoped=true&"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=87c2b412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c2b412",
  null
  
)

export default component.exports